/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FinesList.module.scss'
import { useHistory } from 'react-router-dom'
import AddFineView from './AddFineView'
import FinesListTable from './FinesListTable'
import InfoDisplay from './InfoDisplay'
import BackAnchor from '../../../../shared/components/BackAnchor'

const FinesListView = ({ t, i18n, setIsError }) => {
  let history = useHistory()

  const onNextClick = () => {
    history.push(`/${i18n.language}${t('routes.contact_info')}`)
  }

  return (
    <div className="container">
      <BackAnchor />
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <InfoDisplay />
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h2>{t('fines_list.summary_of_fines')}</h2>
        </div>
      </div>
      <FinesListTable setIsError={setIsError} />
      <div className="col-xs-12 col-md-8">
        <button
          className={['btn-lg btn-default', styles['next_button']].join(' ')}
          onClick={onNextClick}
          value={t('fines_list.next')}
          name={t('fines_list.next')}
        >
          {t('fines_list.next')}
        </button>
      </div>
      <div>
        <AddFineView t={t} setIsError={setIsError} />
      </div>
    </div>
  )
}

export default withTranslation('common')(FinesListView)
